import React from "react";

export default function Statistics_Probability() {
  return (
    <div>
      <h1>Statistics_Probability</h1>
      <p>This is the Statistics_Probability component.</p>
    </div>
  );
}
